// Initializing Supabase client with environment variables
import { createClient } from '@supabase/supabase-js';

const defaultUrl = 'https://supabase.saydevs.com';
const defaultKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzgzMzk3MTcyLCJleHAiOjIwOTg3NTcxNzJ9.OxTdpzSRtOzNTRvHotcWN6w7oBqyyhRcwBeJALHsO1s';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || defaultUrl;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || defaultKey;

export const supabase = createClient(
    supabaseUrl,
    supabaseAnonKey,
    {
        db: {
            schema: 'carbon_case_sv'
        },
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
            lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => {
                return await fn();
            }
        }
    }
);

